import {ITechnicalApplicationEditModel} from './i-technical-application-edit-model';
import {TechnicalApplicationCategoryModel} from './technical-application-category-model';
import {ImageModel} from './image-model';

export class AddTechnicalApplicationModel implements ITechnicalApplicationEditModel {
  static build(category: TechnicalApplicationCategoryModel, icon: ImageModel) {
      const result = new AddTechnicalApplicationModel();
      result.calc = category.calc;
      result.categoryId = category.id;
      result.defaultRatio = '1:1';
      result.state = 'A';
      result.virginHair = 'N';
      result.wet = 'N';
      result.iconURL = icon.url;
      result.maxSize = 0;
      result.minSize = 0;
      result.foilCount = 0;
      return result;
  }

  executorId:	string;
  id:	string;
  name:	string;
  categoryId:	string;
  minSize:	number;
  maxSize: number;
  iconURL: string;
  defaultRatio:	string;
  foilCount: number;
  wet: string;
  virginHair:	string;
  state:	string;
  calc:	string;
}
